// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_N1ac6","active":"style_active_3_AlO","body":"style_body_2_JY2","label":"style_label_3tYIu","unread":"style_unread_113Kr"};